/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { LoadCarriers } from '../../models/load-carriers';
import { PutLoadCarrierRequest } from '../../models/put-load-carrier-request';

export interface PutConsigneeLoadCarriersV3$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;

/**
 * version from the `ETag` of the GET
 */
  'If-Match'?: string;
      body: PutLoadCarrierRequest
}

export function putConsigneeLoadCarriersV3(http: HttpClient, rootUrl: string, params: PutConsigneeLoadCarriersV3$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadCarriers>> {
  const rb = new RequestBuilder(rootUrl, putConsigneeLoadCarriersV3.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.header('If-Match', params['If-Match'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoadCarriers>;
    })
  );
}

putConsigneeLoadCarriersV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/load-carriers';
